export default __webpack_public_path__ + "static/media/style.c4c6a06e.less";